'use client';
var styles = {"article":"ToastNotice-module_article__JhsVG","center":"ToastNotice-module_center__DQ-0D","text":"ToastNotice-module_text__nGLRI","button-right":"ToastNotice-module_button-right__cK2-y"};

export { styles as default };
